import React, { useState, useEffect } from "react"
import { doc, setDoc, Timestamp } from "firebase/firestore"
import { db } from "../firebase"
import { postHttp } from "../api/HttpClient"

const VerifyPayment = ({ paymentData, currentUser, onUpdate }) => {
  const [loading, setLoading] = useState(false)
  let isMounted = true // Flag to track if the component is mounted

  console.log("Payment data", paymentData)

  useEffect(() => {
    // Cleanup function to set isMounted to false when the component unmounts
    return () => {
      isMounted = false
    }
  }, [])

  const handleVerifyPayment = async () => {
    setLoading(true)

    if (paymentData?.payment_id > 0 && paymentData?.status !== 2) {
      const body = {
        order_owner: "Qr",
        payment_id: paymentData.payment_id,
      }

      const { response, success, errorData } = await postHttp("verify", body)
      console.log(response)
      console.log(success)
      console.log(errorData)

      if (success) {
        if (response?.state) {
          if (response?.state === 2) {
            const updatedSubscription = {
              ...paymentData,
              subscription: true,
              status: response?.state,
              lastPayment: new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }).format(new Date()),
              expiration_date: Timestamp.fromDate(
                new Date(`${new Date().getFullYear()}-12-31T23:59:59Z`)
              ),
            }

            // Update Firestore
            const subRef = doc(
              db,
              `usersNew/${currentUser.uid}/subscriptions/${currentUser.year}`
            )
            const topLevelSubRef = doc(
              db,
              `subscriptions/${currentUser.uid}_${currentUser.year}`
            )

            await setDoc(subRef, updatedSubscription, { merge: true })
            await setDoc(topLevelSubRef, updatedSubscription, { merge: true })

            // Notify parent component of the update
            if (isMounted) onUpdate(updatedSubscription)
          } else if (
            response?.state === 6 ||
            response?.state === 98 ||
            response?.state === "98"
          ) {
            // console.log("I am here")
            const updatedSubscription = {
              ...paymentData,
              subscription: false,
              payment_id: 0,
              status: 0,
            }

            // Update Firestore
            const subRef = doc(
              db,
              `usersNew/${currentUser.uid}/subscriptions/${currentUser.year}`
            )
            const topLevelSubRef = doc(
              db,
              `subscriptions/${currentUser.uid}_${currentUser.year}`
            )
            console.log("Subscription not valid, resetting payment data")

            await setDoc(subRef, updatedSubscription, { merge: true })
            await setDoc(topLevelSubRef, updatedSubscription, { merge: true })

            // Notify parent component of the update
            if (isMounted) onUpdate(updatedSubscription)
          }
        }
      } else {
        const { error } = errorData
        if (isMounted) alert(error)
      }
    }

    if (isMounted) setLoading(false)
  }

  return (
    <button
      onClick={handleVerifyPayment}
      disabled={loading}
      className='btn btn-primary'
    >
      {loading ? "Verifying..." : "Verify Payment"}
    </button>
  )
}

export default VerifyPayment
